export default __webpack_public_path__ + "locales/ja-JP/WebPlugins.json?hash=9152ba921183b6e501a06b95e7ec1698";